//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "nameplate-engravings.vue",
  props: {
    control: {required: true},
    data: {required: true},
    stonePositions: {required: true},
  },

  methods: {
    onEngravingTextChanged(event, index) {
      if (event) {
        this.$emit('updateValue', {
          controlType: this.control.type,
          controlName: this.control.name,
          controlSubName: index,
          value: event.target.value,
        })
      }
    },

  }
}
